<template>
<div class="relative">
  <div @click="showInfo = true" @mouseleave="showInfo = false" class="flex items-center font-semibold mt-8 mb-4 cursor-pointer">
    <span class="mr-1">{{title}} </span>
    <InfoIcon/>
  </div>
  <slot v-show="showInfo" name="rowContent"></slot>    
  <EmptyState v-if="pages.length < 1 && isGroup == false" :text="text"/>
  <AddGroup v-if="pages.length < 1 && isGroup" :canAddGroup="canAddGroup" @addGroups="$emit('addGroups')"/>
  <InfoPopUp v-show="showInfo" :information="information" />
</div>

</template>

<script>
import InfoIcon from '@/components/svg/InfoIcon';
import AddGroup from '@/components/settings/social/partials/ConnectedRow/partials/AddGroup';
import InfoPopUp from '@/components/settings/social/partials/ConnectedRow/partials/InfoPopUp';
import EmptyState from '@/components/settings/social/partials/ConnectedRow/partials/EmptyState';

export default {
name:"ConnectedRow",

components: {
  InfoIcon,
  AddGroup,
  InfoPopUp,
  EmptyState
},

data() {
  return {
    showInfo: false
  }
},

props: {
  title: {
    type: String,
    default: 'Instagram Accounts'
  },
  text:{
    type:String,
    default:'Link a Facebook account to access Pages '
  },
  information:{
    type:String,
    default:'This account is automatically pulled from your linked Facebook account Pages' 
  },
  pages:{
    type:Array,
    require:true,
  },
  isGroup:{
    type:Boolean,
    default:false
  },
  canAddGroup: {
    type: Boolean,
    default: false,
  }
},
}
</script>
 